<template>
    <div class="text-center">
       <div class="invoice-status success bold-span" :class="[data.status === 'Suspended' ? 'danger' : data.status === 'Deactivated' ? 'success' : data.status === 'Active' ? 'paidColor' : 'yelloInvoiceColor']">
            {{data.status}}
       </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {}
        }
    }
 }
</script>